export type BunnyPlayerTestMode = 'automatic' | 'bunny' | 'vidstack';
export type BunnyPlayerTestSkipMode = 'default' | 'allow' | 'prevent' | 'completed';

export interface BunnyPlayerTestSettings {
  mode: BunnyPlayerTestMode;
  skipMode: BunnyPlayerTestSkipMode;
  showDiagnostics: boolean;
}

export const defaultBunnyPlayerTestSettings: BunnyPlayerTestSettings = {
  mode: 'automatic',
  skipMode: 'default',
  showDiagnostics: false
};
